import type { FC } from "react";
import { memo } from "react";

import TelemetryButton from "@/design-system/telemetry-button";
import ImageLoader from "@Components/ImageLoader";
import { BannerEventType, TelemetryEntity } from "@Components/Modules/Helpers";
import Text from "@Components/Text";
import TelemetryHoc from "@Components/telemetry-hoc/telemetry-hoc";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, colors, globalLimitStyles } from "../../../styles/tokens.stylex";

export type IBannerTile = {
    id: string;
    title?: string;
    bannerImageUrl: string;
    navigateBannerUrl?: string;
    trackerUrl?: string;
};

const BannerTile: FC<IBannerTile> = memo((props) => {
    return (
        <TelemetryHoc
            telemetryCustom={{
                eventName: `${TelemetryEntity.Cashback}-${BannerEventType.Banner}`,
                actionType: "View",
                itemId: props.id,
            }}
        >
            <TelemetryButton
                as="a"
                target="_self"
                size="None"
                id={props.id}
                href={props.navigateBannerUrl}
                styleX={styles.linkWrapper}
                eventName={`${TelemetryEntity.Cashback}-${BannerEventType.Banner}`}
            >
                <ImageLoader
                    src={props.bannerImageUrl}
                    alt={props.title}
                    srcSetAxis="width"
                    size={600}
                    styleX={styles.bannerImg}
                />
                {props.title && (
                    <Text
                        textElement="p"
                        fontWeight="bold"
                        fontStyle="primaryText"
                        styleX={[globalLimitStyles.TextTwoLinesCap, styles.bannerDesc]}
                    >
                        {props.title}
                    </Text>
                )}
            </TelemetryButton>
        </TelemetryHoc>
    );
});

const styles = stylex.create({
    linkWrapper: {
        aspectRatio: "3/2",
        borderRadius: 0,
        display: "block",
        padding: 0,
        width: "100%",
    },

    bannerImg: {
        borderRadius: ComposableSpacing.s2,
        boxShadow: "inset 0 0 10px 0 rgba(0, 0, 0, 0.2)",
        objectFit: "cover",
        width: "100%",
    },

    bannerDesc: {
        color: colors.grayDark,
        paddingTop: "10px",
        textAlign: "left",
    },
});

export default BannerTile;
